// erp
const map = {
  // erp
  erpShopList: () => import('@/views/erp/ErpShopList'),
  erpWarehouseList: () => import('@/views/erp/ErpWarehouseList'),
  erpSupplierList: () => import('@/views/erp/ErpSupplierList'), // ERP供应商
  erpBrandList: () => import('@/views/erp/ErpBrandList'), // ERP货品品牌
  erpGoodsList: () => import('@/views/erp/ErpGoodsList'), // ERP单品列表
  // erpOrder订单
  erpOriginalOrder: () => import('@/views/erpOrder/ErpOriginalOrder'), // ERP原始订单
  erpOrderList: () => import('@/views/erpOrder/ErpOrderList'), // 订单管理
  // erp库存
  erpSalesStorehouse: () => import('@/views/erpRepertory/ErpSalesStorehouse') // ERP原始订单
}

export default map
